import React from "react";
import "./letsConnect.scss";

const LetsConnect = () => {
  return (
    <div>
      <section id="lets-connect" className="mt-5">
        <h1 className="pb-md-4 title-2 title-md-1">Let's connect</h1>
        <div className="connect">
          <p className="color-lighter text-1 text-md-1 pb-3">What's next?</p>
          <h1 className="title-5 title-md-4">
            Get in touch, my inbox is always open for discussion on technology
            with a cup of coffee or if you have a questions, suggestions, advice
            or just want to say hi..
          </h1>
          <h1 className="title-5 title-md-4 pt-4">
            I'll try my best to get back to you!
          </h1>
          <div className="d-flex justify-content-center pt-5">
            <a
              href="mailto:vipulzambare1993@gmail.com"
              className="btn-view-my-work"
            >
              Say hi
            </a>
          </div>
          <footer className="pt-md-4 mt-md-4">
            <span>Copyright © 2020</span>
            <p>Created with React and Firebase by Vipul Zambare.</p>
          </footer>
        </div>
      </section>
    </div>
  );
};

export default LetsConnect;
